import React, {Component} from "react";
import {Button, Card, CardBody, Col, Row} from "reactstrap";
import {withRouter} from "react-router";
import Select from "react-select";
import {connect} from "react-redux";
import moment from "moment";
import {
  getFinancicalSchemasTemplate,
  getFinancicalSchemas,
  emptyFinStrErrors
} from "../../../store/actions";
import Modal from "./Modal";
import FinStrAgGrid from "./FinStrAgGrid";

class Tables extends Component {
  state = {
    isOpenTab: -1,
    isOpen: false,
    showmodal: false,
    select: {
      value: "active",
      label: "Active"
    },
  };

  componentDidMount() {
    const {getFinancicalSchemasTemplate} = this.props;

    getFinancicalSchemasTemplate();
  }

  toggle = () => {
    this.setState({
      showmodal: false
    });
  };

  isOpenTabIndexChange = (id, toggle) => {
    const {emptyFinStrErrors} = this.props;

    this.setState({isOpenTab: !toggle ? -1 : id, isOpen: toggle});
    emptyFinStrErrors();
  };

  render() {
    const {isOpenTab, select, showmodal} = this.state;
    const {financicalSchemas, finschemaCreate, finSchemasName} = this.props;
    const options = [{value: "active", label: "Active"}, {value: "archive", label: "Archive"}];

    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div>
                  <span style={{float: "left", display: "inline"}}>
                    Financical Structure
                  </span>
                  <Button
                    style={{float: "right"}}
                    onClick={() => {
                      this.setState({showmodal: true});
                    }}
                    color="primary"
                  >
                    Add New
                  </Button>
                </div>

                <div style={{width: "150px", float: "right"}}>
                  <Select
                    clearable={false}
                    placeholder={"filter"}
                    value={select}
                    onChange={this.handleSelect}
                    options={options}
                  />
                </div>

                <div
                  className="ag-theme-material"
                  style={{
                    height: "400px",
                    width: "100%",
                    marginTop: "50px"
                  }}
                >
                  {financicalSchemas.res &&
                  financicalSchemas.res.results.map((data, i) => {
                    return (
                      <React.Fragment key={i}>
                        <div style={{display: 'flex'}}>
                          <i className={"fa " + (isOpenTab === i ? "fa-angle-up " : "fa-angle-down ")} onClick={() => {
                            this.isOpenTabIndexChange(i, isOpenTab === i ? false : true);
                          }
                          }/>
                          <div style={{display: 'flex'}}>
                            <p>{data.name}</p>
                            <p>{moment(data.created_at).format("DD-MM-YYYY")}</p>
                            <p>{data.version}</p>
                            <p>{data.id}</p>
                          </div>
                        </div>
                        {isOpenTab === i &&
                        <FinStrAgGrid isOpenTabIndexChange={this.isOpenTabIndexChange} finStrIndex={i} finStrData={data}
                                      finSchemaNew={false}/>}
                      </React.Fragment>
                    )
                  })}
                  {finschemaCreate &&
                  <React.Fragment>
                    <div style={{display: 'flex'}}>
                      <i className={"fa " + (isOpenTab === 'newFinStrId' ? "fa-angle-up " : "fa-angle-down ")}
                         onClick={() => {
                           this.isOpenTabIndexChange('newFinStrId', isOpenTab === 'newFinStrId' ? false : true);
                         }
                         }/>
                      <div style={{display: 'flex'}}>
                        <p>{finSchemasName}</p>
                      </div>

                    </div>
                    {isOpenTab === 'newFinStrId' &&
                    <FinStrAgGrid isOpenTabIndexChange={this.isOpenTabIndexChange} finStrIndex={100000}
                                  finSchemaNew={true}/>}
                  </React.Fragment>
                  }
                </div>

                <Modal
                  isOpen={showmodal}
                  isOpenTabIndexChange={this.isOpenTabIndexChange}
                  toggle={this.toggle}
                  {...this.props}
                />

              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    allSchemas: state,
    finSchemasName: state.schemas.name,
    financicalSchemas: state.financicalSchemas,
    finschemaCreate: state.financicalSchemas.finschemaCreate,
    showIcon: state.financicalSchemas.showIcon,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      getFinancicalSchemasTemplate,
      getFinancicalSchemas,
      emptyFinStrErrors
    }
  )(Tables)
);



// WEBPACK FOOTER //
// ./src/views/FinancicalStructure/FinancicalStructure/Table.js